// extracted by mini-css-extract-plugin
module.exports = {"draw":"ArtifactDraw_draw__EDOyC","glasses":"ArtifactDraw_glasses__f5JRC","go-detail":"ArtifactDraw_go-detail__2LvjB"};